// import { SWRConfig } from "swr";
import EasyNews from "../containers/EasyNews/EasyNews";

const EasyNewsPage = (props) => {
  return <EasyNews {...props} />;
};

export async function getStaticProps() {
  const res = await fetch(process.env.API_URL + "/articles");
  const articles = await res.json();
  const res2 = await fetch(process.env.API_URL + "/events");
  const events = await res2.json();
  // const res3 = await fetch(process.env.API_URL + "/article-tags");
  // const articleTags = await res3.json();

  return {
    props: {
      articles,
      events,
      // articleTags,
    },
    revalidate: 60,
  };
}

export default EasyNewsPage;
// const EasyNewsPage = ({ fallback }) => {
//   return (
//     <SWRConfig value={{ fallback }}>
//       <EasyNews />;
//     </SWRConfig>
//   );
// };

// export async function getStaticProps() {
//   const res3 = await fetch(process.env.API_URL + "/article-tags");
//   const articleTags = await res3.json();
//   const res = await fetch(process.env.API_URL + "/articles");
//   const articles = await res.json();
//   const res2 = await fetch(process.env.API_URL + "/events");
//   const events = await res2.json();

//   return {
//     props: {
//       fallback: {
//         [process.env.API_URL + "/articles"]: articles,
//         [process.env.API_URL + "/events"]: events,
//         [process.env.API_URL + "/article-tags"]: articleTags,
//       },
//     }
//   };
// }

// export default EasyNewsPage;
